import { useEffect, useRef } from "react";

/** The scrolling lines: current line big and bright (with a fill showing how far through it you are), next lines dimmer. */
export default function PrompterLines({ timed, current, time, onSeek, big }) {
  const box = useRef(null);
  useEffect(() => {
    const el = box.current?.querySelector(`[data-line="${Math.max(0, current)}"]`);
    if (el) box.current.scrollTo({ top: el.offsetTop - box.current.clientHeight / 2 + el.clientHeight / 2, behavior: "smooth" });
  }, [current]);
  return (
    <div ref={box} data-testid="prompter-lines" className={`relative overflow-y-auto scroll-smooth pr-1 ${big ? "h-[300px]" : "h-[210px]"}`}>
      <div className={big ? "h-[120px]" : "h-[80px]"} />
      {timed.map((l, i) => {
        if (l.label) return <p key={i} data-line={i} className="mb-1 mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-rose-200/60">{l.text}</p>;
        const on = i === current;
        const pct = on ? Math.min(100, Math.max(0, ((time - l.start) / Math.max(0.01, l.end - l.start)) * 100)) : 0;
        return (
          <button key={i} type="button" data-line={i} data-testid={`prompter-line-${i}`} data-current={on ? "1" : "0"} onClick={() => onSeek?.(l.start)} disabled={!onSeek}
            className={`relative block w-full rounded-lg px-2 py-1 text-left font-display transition-[color,opacity,font-size] duration-300 ${on ? `${big ? "text-3xl" : "text-2xl"} font-bold text-white` : i < current ? "text-base text-white/25" : `${big ? "text-xl" : "text-lg"} text-white/55`} ${onSeek ? "hover:bg-white/[0.04]" : ""}`}>
            {l.text}
            {on ? <span aria-hidden className="absolute bottom-0 left-2 h-[3px] rounded-full bg-gradient-to-r from-rose-400 to-amber-300" style={{ width: `calc(${pct}% - 16px)` }} /> : null}
          </button>
        );
      })}
      <div className={big ? "h-[160px]" : "h-[110px]"} />
    </div>
  );
}
